import { useCallback, useState } from 'react';
import { assistantApi } from '../services/api';
import { assistantEndpoints } from '../utils/commonVariables/endpoints';

const useDataAssistant = key => {
    const [isLoadingAssistant, setIsLoadingAssistant] = useState(false);
    const [error, setError] = useState('');
    const [answer, setAnswer] = useState('');

    const askQuestion = useCallback(
        async (question, parameters) => {
            if (!key) {
                setError('Prompt key not provided');
                return;
            }

            setIsLoadingAssistant(true);
            setError('');
            setAnswer('');

            try {
                const { data } = await assistantApi.post(
                    assistantEndpoints.askAssistant,
                    {
                        promptKey: key,
                        question: question || '.',
                        parameters,
                    }
                );
                setAnswer(data.response);
            } catch (err) {
                setError('an_error_occurred_while_processing_your_request');
            } finally {
                setIsLoadingAssistant(false);
            }
        },
        [key]
    );

    const resetAssistant = useCallback(() => {
        setIsLoadingAssistant(false);
        setError('');
        setAnswer('');
    }, []);

    return {
        isLoadingAssistant,
        assistantError: error,
        answer,
        askQuestion,
        resetAssistant,
    };
};

export default useDataAssistant;
